export default __webpack_public_path__ + "faee1bdc056158286f61a6ab43b04e86.png";